import React from "react";
import { Link } from "react-navi";
import siteMetadata from "../siteMetadata";
import logoImg from "../assets/logo.png";
import styles from "./BlogHeader.module.css";

function BlogHeader({ blogRoot }) {
  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <Link href={blogRoot} className={styles.brand}>
          <img src={logoImg} alt="VoiceTyping" className={styles.logo} />
          <span className={styles.brandName}>{siteMetadata.title}</span>
        </Link>

        <nav className={styles.nav}>
          <Link href="/tags" className={styles.navLink}>
            Tags
          </Link>
          <Link href="/about" className={styles.navLink}>
            About
          </Link>
          <a href="/rss.xml" className={styles.navLink}>
            RSS
          </a>
          <a href="https://voicetyping.xyz/" className={styles.navLink}>
            Home
          </a>
        </nav>

        <div className={styles.actions}>
          <a href="https://voicetyping.xyz/login" className={styles.btnOutline}>
            Sign in
          </a>
          <a
            href="https://voicetyping.xyz/login"
            className={styles.btnPrimary}
          >
            Start free
          </a>
        </div>
      </div>
    </header>
  );
}

export default BlogHeader;
